export default __webpack_public_path__ + "static/media/logo_fullwidth.462db6b8.png";